class WFFormLabel {
  constructor() {
    setInterval(() => {
      this.init();
    }, 500)

  }

  init() {
    document.querySelectorAll('.form-group .form-control').forEach((elem) => {
      if (!elem.classList.contains('wf-initialized')) {
        elem.addEventListener('focus', this.onFieldFocus.bind(this));
        elem.addEventListener('blur', this.onFieldBlur.bind(this));
        elem.addEventListener('change', this.onFieldChange.bind(this));
        elem.classList.add('wf-initialized');
      }
    });
    document.querySelectorAll('.file-upload-styles > .form-group .ktc-uploader-text-button').forEach((elem) => {
      elem.addEventListener('click', this.onFileUploadDeleteClick.bind(this));
    });

  }

  onFieldFocus(evt) {
    evt.currentTarget.closest('.form-group').classList.add('active');
  }
  onFieldBlur(evt) {
    evt.currentTarget.closest('.form-group').classList.remove('active');
  }
  onFieldChange(evt) {
    evt.currentTarget.closest('.form-group').classList.toggle('has-value', !!evt.currentTarget.value);
  }
  onFileUploadDeleteClick(evt) {
    evt.currentTarget.closest('.form-group').classList.remove('has-value');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  var label_manager = new WFFormLabel();
})
